import { createRootRoute, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { Provider as JotaiProvider } from 'jotai'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  return (
    <JotaiProvider>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <TanStackRouterDevtools />
      </div>
    </JotaiProvider>
  )
}
